module.exports = __webpack_public_path__ + "media/images/front/banner_group_member_side-4157b4b115201c0d70658ac625b68dba.jpg";